import { render, staticRenderFns } from "./RouterChooseCom.vue?vue&type=template&id=19bcbf14&"
import script from "./RouterChooseCom.vue?vue&type=script&lang=ts&"
export * from "./RouterChooseCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports